<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">
                      <img src="../assets/images/KAMVING.png" alt="" width="225" height="auto">
                </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                </ul>
                <div class="d-flex">
                     <a class="nav-link" @click.prevent=""><span style="color: white; font-size: 25px" > Welcome back <span style="color: red">{{this.name}}</span> !</span></a>
                    <GoogleLogin :params="this.params" :logoutButton=true class="nav-link" style="border: 0; background: rgba(0,0,0,0)">
                        <div @click.prevent="logout" class="btn btn-danger">
                            Logout
                        </div>
                    </GoogleLogin>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import GoogleLogin from 'vue-google-login';
export default {
    name: "navbar",
    components: {GoogleLogin},
    data() {
        return{
            message: "hello world",
            params: {
                client_id: '556677160941-fm1oklv6bj2sm1ej7ml8bdsbflrgu23a.apps.googleusercontent.com'
            }
        }
    },
    methods : {
        logout(){
            console.log('logoouuuuttt')
            this.$emit('logout')
        }
    },
    computed : {
        email (){
            return localStorage.getItem('email')
        },
        name (){
            return localStorage.getItem('name')
        }
    }
}
</script>

<style scoped>

</style>